




















































import { Vue, Component } from "vue-property-decorator";
import RoleItemComponent from "./RoleItem.vue";
import RoleItemNonClickableComponent from "./RoleItemNonClickable.vue";
import RoleFormComponent from "./RoleFormDialog.vue";
import router from "@/router/router";
import { Role } from "@/data/models/User";
import { RoleSettingsModule } from "@/store/modules/RoleSettingsModule";
import { UserModule } from "@/store/modules/UserModule";
import { defineOwnRoleSettingsClientAccess } from "@/permissions/ClientPermissions";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";
import { COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK } from "@/utils/colors";
import { themed } from "@/utils/Theme";

@Component({
  components: {
    "role-item": RoleItemComponent,
    "role-item-non-clickable": RoleItemNonClickableComponent,
    "role-form": RoleFormComponent,
  },
})
export default class RoleManagementComponent extends Vue {
  roles = Object.values(Role);

  /** Table header background: light grey in light mode, dark elevated surface in dark mode. */
  get tableHeaderColor() {
    return themed(COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK);
  }

  get roleSettings() {
    return RoleSettingsModule.roleSettings;
  }

  get users() {
    return UserModule.users;
  }

  get isRoleEditable() {
    return defineOwnRoleSettingsClientAccess(true);
  }

  isRoleDeviceManager(role: Role) {
    if (role == Role.CUSTOM_ROLE_5) {
      return true;
    }
    return false;
  }

  onEditRoles() {
    // Programmatic Navigation
    // https://router.vuejs.org/guide/essentials/navigation.html
    router.push({
      path: "roleManagement/permissionTable",
      replace: true,
    });
  }

  mounted() {
    this.setToolbarTitle();
  }

  setToolbarTitle() {
    const baseTitle = this.$t("pages.settings").toString();
    const currentPageTitle = this.isRoleEditable
      ? this.$t("settings.roleManagement.title").toString()
      : this.$t("settings.roleManagement.titleAlt").toString();

    const toolbarTitle = baseTitle + " > " + currentPageTitle;

    ToolbarContentModule.setToolbarTitle(toolbarTitle);
  }
}
